<template>
  <v-container>
    <div class="_fs-36 mt-8 mt-md-1">
      ช่องทางการติดต่อ
    </div>
    <div class="mt-4 _fs-20">
      ข้อมูลติดต่อบริษัท เซลสุกิ จำกัด
    </div>

    <v-divider class="my-4"></v-divider>
    <v-card class="pa-10">
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="d-flex flex-column justify-center">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3874.6124668483235!2d100.57508089999999!3d13.802219800000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29b9965e38b7d%3A0x58274f3a60db01fe!2zU2VsbHN1a2kgKOC5gOC4i-C4peC4quC4uOC4geC4tCk!5e0!3m2!1sen!2sth!4v1669624465091!5m2!1sen!2sth%22"
            width="100%"
            height="400"
            style="border:0;"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          />
        </v-col>
        <v-col
          cols="12"
          md="6">
          <v-list
            dense
            nav>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-map-marker-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="pt-2 _fs-14">
                บริษัท เซลสุกิ จำกัด (สำนักงานใหญ่) <br />
                เลขที่ผู้เสียภาษี / Tax ID 0105557075681 <br />
                เลขที่ 10/39 ชั้น 3 ถนนรัชดาภิเษก <br />
                แขวงจันทรเกษม เขตจตุจักร กรุงเทพมหานคร 10900
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-email-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="pt-2 _fs-14">
                lineagency@sellsuki.com
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <img src="/svg/contact-us/Facebook.svg" />
              </v-list-item-icon>
              <v-list-item-content class="pt-2 _fs-14">
                <a
                  href="https://facebook.com/lineagency.sellsuki"
                  class="blue--text">
                  facebook.com/lineagency.sellsuki
                </a>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <img src="/svg/contact-us/LINE.svg" />
              </v-list-item-icon>
              <v-list-item-content class="pt-2 _fs-14 blue--text text-decoration-underline">
                <span
                  style="cursor: pointer"
                  @click="dialog = true"> @linebysellsuki </span>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <img src="/svg/contact-us/Phone.svg" />
              </v-list-item-icon>
              <v-list-item-content class="pt-2 _fs-14">
                <a
                  href="tel:020263250"
                  class="blue--text py-1"> 02-026-3250 </a>
                กด 1 สอบถามเรื่องแพ็กเกจ <br />
                กด 2 สอบถามเรื่องการใช้งาน <br />
                กด 3 ติดต่อแผนกบัญชี
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="700">
      <v-container class="dialog-line-agency">
        <v-row>
          <v-col
            cols="12"
            class="text-right pt-8 pr-8">
            <v-icon
              color="black"
              @click="dialog = false">
              mdi-close
            </v-icon>
          </v-col>
          <v-col
            class="text-center"
            cols="12">
            <img
              src="/img/qr-line-agency.png"
              loading="lazy"
              alt="Space Banner Image"
              width="204px"
              height="204px"
              style="border: 1px solid black"
            />
          </v-col>
          <v-col
            cols="12"
            class="_fs-24 text-center">
            สแกนคิวอาร์โค้ดเพื่อเพิ่มเพื่อน LINE
          </v-col>
          <v-col
            cols="12"
            class="_fs-16 text-center">
            โปรดสแกนคิวอาร์โค้ดนี้ด้วยตัวสแกนโค้ดในแอป LINE
          </v-col>
          <v-col
            cols="12"
            class="_fs-16 text-center pb-12">
            <v-btn
              color="primary"
              width="100%"
              max-width="100px"
              rounded
              @click="dialog = false">
              ปิด
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'ContactUsPage',
  data() {
    return {
      dialog: false
    }
  }
}
</script>

<style>
.dialog-line-agency {
  max-width: 700px;
  background-color: #fff;
  border-radius: 15px;
}
</style>
